/**
 * Finds and returns the best CSRF token to use with requests
 *
 * @returns {String} the csrf token, or an empty string if none is found
 */
const csrfToken = (cookie = document.cookie) => {
  if (cookie.includes('csrftoken')) {
    const csrfArray = cookie.split('csrftoken=');

    return csrfArray[csrfArray.length - 1].split(';')[0].trim();
  }

  return '';
};

export default csrfToken;
